import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue } from '../../../../Fct/generics/FctParams';
import { FaWallet } from 'react-icons/fa';
import { getSupportedTokens } from '../../../../Fct/plugins/allowanceRequiredProtocols';
export var BalanceOf = createPlugin({
    protocol: 'ERC20',
    type: 'GETTER',
    method: 'balanceOf',
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({
                    destination: 'erc20',
                    options: getSupportedTokens({ chainId: chainId }),
                    isPreview: true,
                }),
                methodParams: {
                    owner: new FctAddress({ isPreview: true, icon: FaWallet }),
                },
            },
            output: {
                balance: new FctValue({ destination: 'wei_amount', innerIndex: 0 }),
            },
        });
    },
});
